import { WaveForm } from "../../../../../../library-js/audio/visualization/wave-form/WaveForm";
import { WaveformChannelType, WaveformGenerationOptions } from "../../../../../../library-js/audio/visualization/wave-form/WaveFormGenerationOptions";
import { WaveFormRenderer } from "../../../../../../library-js/audio/visualization/wave-form/WaveFormRenderer";
import { AttributeValue } from "../../../../../../library-js/dom-tools/AttributeValue";
import { ElementType } from "../../../../../../library-js/dom-tools/ElementType";
import { OnChange, OnLoad } from "../../../../../../library-js/dom-tools/EventListeners";
import { KeyboardSensorID } from "../../../../../../library-js/sensors/KeyboardSensorID";
import { AppCommand } from "../../../../../../library-js/web-app/commands/AppCommand";
import { AppCommandBinding } from "../../../../../../library-js/web-app/commands/AppCommandBinding";
import { AppCommandBindingEntry } from "../../../../../../library-js/web-app/commands/AppCommandBindingEntry";
import { AppCommandContext } from "../../../../../../library-js/web-app/commands/AppCommandContext";
import { AudioEditor } from "../../AudioEditor";

export class LoadSound extends AppCommand
{
  initialize()
  {
    this._name = 
    {
      en: "Load Sound",
      de: "Sound laden" 
    }

    this._info = 
    {
      en: "Shows a dialog to import a sound",
      de: "Zeigt einen Dialog um einen Sound zu importieren"
    }

    this._shortCutEntries = 
    [
      AppCommandBindingEntry.forDesktop( AppCommandBinding.primaryWith( KeyboardSensorID.Key_L ) )
    ]
  }

  async _execute( commandContext:AppCommandContext<any,any> ):Promise<void>
  {
    let app = commandContext.webApp as AudioEditor;

    let promise = new Promise<void>(
      ( resolve, reject )=>
      {
        let input = ElementType.input.create();
        AttributeValue.type_file.set( input );

        OnChange.add( input, 
          ( e:InputEvent )=>
          {
    
            var file = input.files.length === 0 ? null : input.files[ 0 ]; 
    
            if ( ! file )
            {
              resolve();
              return;
            }
    
            var reader = new FileReader();
            
            OnLoad.add( reader, 
              async ( e ) =>
              {                

                let result = reader.result as ArrayBuffer;
                console.log( reader );

                
                let options = new WaveformGenerationOptions();

                options.highestZoomLevel = 1;
                options.lowestZoomLevel  = 20;
                options.type = WaveformChannelType.EXTREMES;
        
                console.log( "wave-form-tester: loading wave data" );
                let waveforms = await WaveForm.loadFromBuffer( result, app.audioContext, options ); 

                let audioBuffer = waveforms[ 0 ].original;
                
                app.project.audioBuffer = audioBuffer;
                app.ui._waveformView.setWaveForms( waveforms );                
              }
            )

            reader.readAsArrayBuffer( file ); 
    
          } 
        );
    
        input.click();
      }
    );
    
    

  
    
    

    return Promise.resolve( promise );
  }
}